export function pageProgressBar() {
    let $scrollProgree = $(".scroll-down");
    let $linkedinLink = $(".linkedin-link");

    function progressBarScroll() {
        let winScroll = document.body.scrollTop || document.documentElement.scrollTop,
            height = document.documentElement.scrollHeight - document.documentElement.clientHeight,
            scrolled = (winScroll / height) * 100;
        document.getElementById("page-progress-bar").style.height = scrolled + "%";
    }

    function linkedinIndent() {
        let $linkedinLinkTop = $linkedinLink.offset().top;
        let $scrollProgreeTop = $scrollProgree.offset().top;
        let $scrollProgreeHeignt = $scrollProgree.innerHeight();
        if ($scrollProgreeTop + $scrollProgreeHeignt + 10 > $linkedinLinkTop) {
            $linkedinLink.addClass("shifted");
        } else {
            $linkedinLink.removeClass("shifted");
        }
    }

    window.onload = function () {
        progressBarScroll();
        linkedinIndent();
    };
    window.onscroll = function () {
        progressBarScroll();
        linkedinIndent();
    };
}


// WEBPACK FOOTER //
// ./assets/js/modules/pageProgressBar.js